import * as defaultImport from "@splunk/react-ui/Heading";
export * from "@splunk/react-ui/Heading";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
